// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2bc6565f] label.circle-green + label {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
